

<p style="font-size: 17px">Assessment Comments</p>
<div class="border">
    <div class="conversation-box mb-2" *ngFor="let c of comments" >
        <p style="font-size: 12px; color: #A77800;font-weight: bold; margin: 0">{{c?.reporter}} &nbsp; &nbsp;{{c?.timeCreated | datetime}}</p>
        <p style="color: #999; margin: 0; font-size: 12px;" [innerHTML]="c?.comment"></p>
    </div>
    <a (click)="changeStatus()" class="btn btn-warning" style="background: #A77800 !important; color: white"><span *ngIf="!show">Click to add a comment</span><span *ngIf="show">Collapse</span></a>

    <div *ngIf="show">
        <angular-editor [(ngModel)]="htmlContent" [config]="editorConfig" *ngIf="canWrite"></angular-editor>

        <div class="mt-3 mb-2" *ngIf="canWrite">
            <button class="s-button" style="background-color: #A57F00" (click)="saveAssessmentComments()" [disabled]="sending">Send</button>
            <button class="s-button" style="background-color: #6B6C7E" (click)="clearText()">Cancel</button>
        </div>
    </div>
</div>